import { render, staticRenderFns } from "./PackageFormatView.vue?vue&type=template&id=2b03815c&scoped=true&lang=html&"
import script from "./PackageFormatView.vue?vue&type=script&lang=js&"
export * from "./PackageFormatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03815c",
  null
  
)

export default component.exports